import React, { useEffect, useRef, useState } from "react";
import { useNavigate } from "react-router-dom";
import { api } from "@/lib/api";
import { toast } from "sonner";
import { Loader2, Sparkles } from "lucide-react";

// REMINDER: DO NOT HARDCODE THE URL, OR ADD ANY FALLBACKS OR REDIRECT URLS, THIS BREAKS THE AUTH
export default function AuthCallback() {
  const navigate = useNavigate();
  const hasProcessed = useRef(false);
  const [error, setError] = useState(null);

  useEffect(() => {
    if (hasProcessed.current) return;
    hasProcessed.current = true;

    const hash = window.location.hash;
    const match = hash.match(/session_id=([^&]+)/);
    if (!match) {
      setError("No session id found");
      return;
    }
    const session_id = match[1];

    // Clean the hash from the URL so we don't reprocess on reload
    window.history.replaceState(null, "", window.location.pathname);

    api.post("/auth/google-session", { session_id })
      .then((res) => {
        localStorage.setItem("gf_token", res.data.token);
        localStorage.setItem("gf_user", JSON.stringify(res.data.user));
        toast.success(`Welcome, ${res.data.user.full_name.split(" ")[0]}!`);
        window.location.href = "/dashboard";
      })
      .catch((err) => {
        setError(err?.response?.data?.detail || "Google sign-in failed");
        setTimeout(() => navigate("/login"), 3000);
      });
    // Only `navigate` is reactive; api, toast, setError, ref, localStorage are stable.
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [navigate]);

  return (
    <div className="min-h-screen bg-[#F9F8F6] flex items-center justify-center p-6" data-testid="auth-callback-page">
      <div className="text-center">
        <div className="inline-flex items-center gap-2 mb-8">
          <div className="w-8 h-8 rounded-md bg-[#1C3F35] flex items-center justify-center">
            <Sparkles className="w-4 h-4 text-white" strokeWidth={2.5}/>
          </div>
          <span className="font-heading text-lg">Beacon of Grants</span>
        </div>
        {error ? (
          <>
            <div className="font-heading text-2xl text-[#C1654B]">{error}</div>
            <p className="text-[#5E5E5E] mt-2 text-sm">Redirecting to sign in…</p>
          </>
        ) : (
          <>
            <Loader2 className="w-10 h-10 text-[#1C3F35] mx-auto animate-spin"/>
            <div className="font-heading text-2xl mt-6">Signing you in…</div>
          </>
        )}
      </div>
    </div>
  );
}
